/**
 * api.ts
 *
 * Client per l'endpoint backend dei trailer.
 * Consuma: GET /wp-json/screenweek/v1/blog/trailers?limit=N
 */

export interface Trailer {
  post_id: number;
  title: string;
  slug: string;
  post_date: string;
  data: {
    url?: string;
    subtitle?: string;
    excerpt?: string;
    thumbnail?: string;
    author?: string;
    video_embed?: string;
    seo?: {
      title?: string;
      description?: string;
    };
  };
}

const BASE_URL = import.meta.env.VITE_BACKEND_API_URL ?? 'https://backend.screenweek.it/wp-json/screenweek/v1';

export async function fetchTrailers(limit = 50): Promise<Trailer[]> {
  const url = `${BASE_URL}/blog/trailers?limit=${limit}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Errore API trailers: ${res.status}`);
  const json: unknown = await res.json();
  // L'endpoint restituisce direttamente un array
  return Array.isArray(json) ? json : [];
}

/**
 * Estrae l'ID video YouTube dall'iframe embed o da una URL YouTube.
 */
export function extractYouTubeId(embed: string): string | null {
  // Match src="...youtube.com/embed/VIDEO_ID..."
  const embedMatch = embed.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/);
  if (embedMatch) return embedMatch[1];

  // Match youtube.com/watch?v=VIDEO_ID
  const watchMatch = embed.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
  if (watchMatch) return watchMatch[1];

  // Match youtu.be/VIDEO_ID
  const shortMatch = embed.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
  if (shortMatch) return shortMatch[1];

  return null;
}

/**
 * Costruisce la thumbnail YouTube in alta qualità.
 */
export function getYouTubeThumbnail(videoId: string): string {
  return `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
}
